
const BASE_URL = process.env.APPLICATION_PATH;

export default {
	
	zoom: 6,
	minZoomMarkers: 10,
	center: [-3.6011, -52.5586],
	
	miniMap: {
		url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
		minZoom: 1,
		maxZoom: 9,
		width: 100,
		height: 100
	},

	baseMaps: [{
		url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
		attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
		default: true,
		name: 'OpenStreetMap',
		minZoom: 4,
		maxZoom: 18
	},
	{
		url: BASE_URL + '/mosaicos/tms?tmsName=rapideye&x={x}&y={y}&z={z}',
		attribution: 'Map data © CAR-Federal',
		default: false,
		tms: true,
		name: 'RapidEye 2011',
		minZoom: 4,
		maxZoom: 15
	},
	{
		url: BASE_URL + '/mosaicos/tms?tmsName=landsat&x={x}&y={y}&z={z}',
		attribution: 'Map data © CAR-Federal',
		default: false,
		tms: true,
		name: 'Landsat 2008',
		minZoom: 4,
		maxZoom: 15
	}],
	
	informacoesSig: 'O Sistema de Informações Geográficas (SIG) permite a visualização, interação e manipulação de informações ' +
					'espacialmente referenciadas. Através de uma interface visual simples e intuitiva, o SIG disponibiliza ao ' +
					'usuário imagens de satélites, mapas temáticos, camadas com polígonos, pontos, linhas, marcadores de referência,' +
					'meta-dados e outras diversas ferramentas como pesquisa, inspeção e exportação de dados.',

	baseReferencia: {
		areaLimiteGeracaoBaseHA: 5000
	},

	inspecao: {
		areaLimiteHA: 5000,
		tamanhoMaximoShapeMB: 10
	}
};



// WEBPACK FOOTER //
// ./src/config.js